import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup, { RadioGroupProps } from "@mui/material/RadioGroup";
import React, { ForwardRefRenderFunction, forwardRef, memo } from "react";

interface GenRadioChoiceProp {
  label: React.ReactNode;
  value: string;
}

export interface GenRadioGroupProps extends RadioGroupProps {
  data: GenRadioChoiceProp[];
  label?: string;
}

const GenRadioGroup: ForwardRefRenderFunction<
  RadioGroupProps,
  GenRadioGroupProps
> = (props, ref) => {
  const { data, label, ...otherProps } = props;
  return (
    <FormControl>
      <RadioGroup {...otherProps} aria-labelledby={label}>
        {data.map((choice) => (
          <FormControlLabel
            key={`${choice.value}-radio-button`}
            value={choice.value}
            control={<Radio />}
            label={choice.label}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export default memo(forwardRef(GenRadioGroup));
